































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  get lang() {
    return this.$store.state.lang;
  }
  private handleEarthDropdownClick(command: any) {
    this.$store.dispatch('setLang', command);
    this.$i18n.locale = command;
  }
}
